import React, {useState} from 'react';
import './ForgotPassword.css';
import Box from '@mui/material/Box';
import { LoadingButton } from '@mui/lab';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import SweetAlert from 'sweetalert2';
import CssTextField from '../../Components/CssTextField';
import { API_URL } from '../../api';
import axios from 'axios';
import { showErrorMessage } from '../../utils';
import {
  Link as MuiLink
} from '@mui/material';
import errorIcon from "../../assets/error-icon.svg"
import successIcon from "../../assets/success-icon.svg"

const ForgotPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);

  // Access individual query parameters by name
  const token = queryParams.get('token');

  const [user, setUser] = useState({
    email: '',
    password: '',
    confirmPassword: ''
  });

  const [waiting, setWaiting] = useState(false)

  const handleSubmit = async (e) => {
    const showErrorAlert = (text) => {
      SweetAlert.fire({
        imageUrl: errorIcon,
        imageHeight: '100px',
        title: 'Oops...',
        text: text,
        confirmButtonColor: '#712d94',
      });
    };
    e.preventDefault();
    if (waiting) return;
    if(token) {
      const { password, confirmPassword } = user;

      if (password === '') {
        showErrorAlert('Please enter a password');
        return;
      }
  
      if (password.length < 6) {
        showErrorAlert('Password should be at least 6 characters long');
        return;
      }

      if (confirmPassword === '') {
        showErrorAlert('Please confirm your password');
        return;
      }

      if (password !== confirmPassword) {
        showErrorAlert('Passwords do not match');
        return;
      }

      setWaiting(true)

      try {
        await axios.post(`${API_URL}/api/auth/forgot_password/confirm`, {password, token})
        SweetAlert.fire({
          // position: 'top-end',
          imageUrl: successIcon,
          imageHeight: '100px',
          title: 'Your password have been reset successfully.',
          html: 'You can use new password',
          width: 600,
          confirmButtonColor: '#712d94',
          customClass: {
            icon: 'no-before-icon',
          }
        });
        navigate('/signin')
      } catch (error) {
        console.log(error);
        showErrorMessage(error.response?.data?.message || "Reset Process confirm failed, please try again!")
      }
      setWaiting(false)

    } else {
      const { email } = user;

      if (email.trim() === '') {
        showErrorAlert('Please enter your email');
        return;
      }

      if (!/^[A-Za-z0-9._+-]+@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)+$/.test(email.trim())) {
        showErrorAlert('Please enter a valid email address');
        return;
      }

      setWaiting(true)

      try {
        await axios.post(`${API_URL}/api/auth/forgot_password/create`, {email})
        SweetAlert.fire({
          // position: 'top-end',
          imageUrl: successIcon,
          imageHeight: '100px',
          title: 'The reset password process have been created successfully.',
          html: 'You should receive an email for verification',
          width: 600,
          confirmButtonColor: '#712d94',
          customClass: {
            icon: 'no-before-icon',
          },
        });
        navigate('/')
      } catch (error) {
        console.log(error);
        showErrorMessage(error.response?.data?.message || "Reset Process create failed, please try again!")
      }
      setWaiting(false)
    }
  };


  return (
    <div className='sign-up-container'>
      <div className="child-profile">
        <div className="child-profile-container">
          <h1 style={{ margin: '8px 0 0' }}>{token ? 'Reset Password' : 'Enter email address'}</h1>
          {!token && (
            <p>Enter your email and we’ll send you a
              reset link</p>
          )}
          <Box
            component="form"
            className="box"
            onSubmit={handleSubmit}
            sx={{
              '& .MuiTextField-root': { m: 1, maxWidth: '100%' },
              '& .captcha': { m: 1, mt: 2 },
              '& .heading': { m: 1, textAlign: 'center' },
            }}
            noValidate
            autoComplete="off"
          >
            <div className="form">
              <hr />
              <br />
              {token ? <>
              <div style={{ width: '100%' }} className='name-box'>
                <CssTextField
                  id="new-password-input"
                  label="New password"
                  type='password'
                  name='new-password'
                  autoComplete='new-password'
                  style={{ flex: 1 }}
                  className="text-field"
                  value={user?.password}
                  onChange={(e) => setUser({ ...user, password: e.target.value })}
                />
              </div>
              <div style={{ width: '100%' }} className='name-box'>
                <CssTextField
                  id="confirm-password-input"
                  label="Confirm password"
                  type='password'
                  name='confirm-password'
                  autoComplete='off'
                  style={{ flex: 1 }}
                  className="text-field"
                  value={user?.confirmPassword}
                  onChange={(e) => setUser({ ...user, confirmPassword: e.target.value })}
                />
              </div>
              </> : <div style={{ width: '100%' }} className='name-box'>
                <CssTextField
                  required
                  id="email-input"
                  label="Email"
                  type="email"
                  style={{ flex: 1 }}
                  value={user?.email}
                  onChange={(e) => setUser({ ...user, email: e.target.value })}
                />
              </div>}
              <span style={{ width: '100%', padding: '0.5rem' }} className='name-box'>
                <LoadingButton
                  type='submit'
                  loading={waiting}
                  variant="contained"
                  size="large"
                  style={{ flex: 1 }}
                >
                  <span>{token ? 'Reset Password' : 'Send Reset Link'}</span>
                </LoadingButton>
              </span>
              <p style={{ width: '100%', padding: '0.5rem', textAlign: 'center', margin: '0' }}>
              Remembered your password?  <MuiLink component={Link} to='/signin' className='link'> Sign in </MuiLink>
              </p>
            </div>
          </Box>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
